import {useAppStore} from '../appStore'

export const initiativesSelectors = {
  useFiltersCount: () => useAppStore(s => s.filtersCount),
  useCurrentFilters: () => useAppStore(s => s.currentFilters),
} as const
